import Default from './Default'
import Empty from './Empty'
import Document from './Document'

export default {
  Default,
  Empty,
  Document,
}
